export enum BUDGET_TYPES {
  Total = 'Total',
  Daily = 'Daily',
}

export enum CAMPAIGN_STATUS {
  Scheduled = 'Scheduled',
  Active = 'Active',
  Completed = 'Completed',
  Archived = 'Archived',
}

export enum CAMPAIGN_TYPES {
  OTT = 'OTT',
  OOH = 'OOH',
  Video = 'VIDEO',
  Display = 'DISPLAY',
  ConnectedTv = 'CONNECTED_TV',
}

export enum CAMPAIGN_TYPE_LABELS {
  OTT = 'OTT',
  OOH = 'DOOH',
  Video = 'VIDEO',
  Display = 'DISPLAY',
  ConnectedTv = 'CONNECTED TV',
}

export enum USER_TYPES {
  Agency = 'AGENCY',
  Brand = 'BRAND',
  DSP = 'DSP',
  SSP = 'SSP',
  AdServer = 'AD_SERVER',
  AdNetwork = 'AD_NETWORK',
}

export enum UI_USER_TYPES {
  ExternalParticipant = 'EXTERNAL_PARTICIPANT',
}

export enum CURRENCIES {
  USD = 'USD',
  SGD = 'SGD',
  IDR = 'IDR',
}

export enum ORG_USER_ROLES {
  Admin = 'ADMIN',
  CampaignManager = 'CAMPAIGN_MANAGER',
  Viewer = 'VIEWER',
  User = 'USER',
}
export enum ORG_USER_ROLES_LABELS {
  ADMIN = 'Admin',
  CAMPAIGN_MANAGER = 'Campaign Manager',
  VIEWER = 'Viewer',
  USER = 'User',
}

export enum ZIL_LINK_TYPES {
  Address = 'Address',
  Transaction = 'Transaction',
}

export enum FORM_FIELDS {
  AlertRule = 'alertRule',
  AlertRuleCheckbox = 'alertRuleCheckbox',
  AlertRuleThreshold = 'alertRuleThreshold',
  CampaignBudget = 'campaignBudget',
  CampaignEndDate = 'campaignEndDate',
  CampaignId = 'campaignId',
  CampaignName = 'campaignName',
  CampaignStartDate = 'campaignStartDate',
  Currency = 'currency',
  DealIds = 'dealIds',
  Dsps = 'dsps',
  MediaOwners = 'mediaOwners',
  PaymentRule = 'paymentRule',
  PaymentRuleCheckbox = 'paymentRuleCheckbox',
  Ssps = 'ssps',
  AdServers = 'adServers',
  Verifier = 'verifier',
}

export enum DEAL_FORM_FIELDS {
  DealId = 'deal_id',
  SSP = 'ssp',
  Currency = 'currency',
  CPM = 'cpm',
  AdNetwork = 'ad_network',
  Publisher = 'publisher',
}

export enum USER_FORM_FIELDS {
  GivenName = 'given_name',
  FamilyName = 'family_name',
  Email = 'email',
  Organization = 'organization',
  Role = 'role',
}
export enum DATASOURCE_FORM_FIELDS {
  Type = 'type',
  Host = 'host',
  Port = 'port',
  User = 'user',
  Password = 'password',
  Database = 'database',
  gcp_project_id = 'gcp_project_id',
  secret_name_prefix = 'secret_name_prefix',
  database1 = 'database1',
}

export enum CONNECTOR_FORM_FIELDS {
  DataCatalog = 'data_catalog',
  Connector = 'connector',
  ConnectorDatabase = 'connector_database',
  LambdaARN = 'lambda_arn',
}

export enum BUCKET_FORM_FIELDS {
  Name = 'name',
  IsLive = 'is_live',
  federationId = 'external_federation_id',
  organizationId = 'external_organization_id',
  datasourceId = 'external_data_source_id',
  TableName = 'external_table_name',
  activation_table_name = 'activation_table_name',
  activation_attribute = 'activation_attribute',
  attribute = 'attribute',
  type = 'type',
  identifier = 'identifier',
  attributesChoose = 'attributesChoose',
}
export enum FIMP_FIELDS {
  SearchCriteria = 'search_criteria',
}
export enum ACTIVATION_FIELDS {
  AudienceName = 'audience_name',
  Acknowledgement = 'acknowledgement',
}

export enum DATA_UPLOAD_FIELDS {
  UploadMethod = 'upload_method',
  ChosenFile = 'chosen_file',
}

export enum UPLOAD_METHODS {
  Csv = 'csv',
  Database = 'database',
}

export enum ANONYMISATION {
  SHA256 = 'hash_sha256',
}

export const ANONYMISATION_LABELS = {
  [ANONYMISATION.SHA256]: 'Hash (SHA256)',
};

export enum NOISE_LEVELS {
  Low = 'low',
  Standard = 'standard',
  High = 'high',
}
export enum NOISE_LABELS {
  low = 'Low',
  standard = 'Standard',
  high = 'High',
}

export enum DATATYPE_LABELS {
  int = 'Integer',
  string = 'String',
  bool = 'Boolean',
}

export enum PURPOSES {
  Identifier = 'identifier',
}

export enum MODIFIERS {
  Matches = 'eq',
  DoesNotMatch = 'neq',
  GreaterThan = 'gt',
  GreaterThanOrEquals = 'gte',
  LessThan = 'lt',
  LessThanOrEquals = 'lte',
  Equals = 'eq',
  NotEqual = 'neq',
  Between = 'Between',
}

export enum CAMPAIGN_DETAIL_FIELDS {
  DatasourceFilter = 'datasourceFilter',
  DateFilterStart = 'dateFilterStart',
  DateFilterEnd = 'dateFilterEnd',
  DateFilterType = 'dateFilterType',
}

export enum TABLE_TYPES {
  Deals = 'deals',
  Campaigns = 'campaigns',
  CampaignOverview = 'campaign_overview',
}

export enum REPORT_TYPES {
  Location = 'location',
  MediaOwner = 'media_owner',
  Daily = 'daily',
  LocationTimeband = 'location_timeband',
  LocationTimebandTable = 'location_timeband_table',
}

export enum DATE_FILTER_TYPES {
  Custom = 'CUSTOM',
  Today = 'TODAY',
  Yesterday = 'YESTERDAY',
  LastSevenDays = 'LAST 7 DAYS',
  LastFourteenDays = 'LAST 14 DAYS',
  LastMonth = 'LAST MONTH',
  AllTime = 'ALL TIME',
}

// Labels for DSPs, Publishers, SSPs, Ad Servers, Viewability Standards
export enum DATASOURCE_LABELS {
  //DSPs
  ttd = 'TTD',
  'the-trade-desk' = 'TheTradeDesk',
  'media-math' = 'MediaMath',
  xandr = 'Xandr',

  //Publishers
  tooplay = 'Tooplay',
  nokta = 'Nokta',

  //SSPs
  rubicon = 'Rubicon',

  //Ad Servers
  sizmek = 'Sizmek',

  //Viewability Standards
  ias = 'IAS',

  //Others
  'fimp' = 'Fimp',
}

export enum COMMON_LABELS {
  Unavailable = 'Unavailable',
}

/**@todo remove all hardcoded mapping values */
export const hardcodedMapping = {
  fimp_pqs_1_default_schema: 'watch_history',
  fimp_pqs_2_default_schema: 'user_demographics',
  fimp_pqs_1: 'Zee5',
  fimp_pqs_2: 'ShareChat',
  fimp_pqs_demo_1: 'Brand A',
  fimp_pqs_demo_2: 'Brand B',
  fimp_pqs_demo_3: 'Brand C',
  airtelads: 'Airtel Ads',
  'airtelads-2': 'Airtel Ads 2',
  pqsaquila15: 'Brand A',
  pqsawstest: 'Brand B',
};

export const getActionLabel = (count, value) => {
  const mapping = {
    queried: `Queried ${count} hashed ad_id${count !== 1 && 's'}`,
    uploaded: `Uploaded ${count} hashed ad_id${count !== 1 && 's'}`,
    activated: `Activated ${count} hashed ad_id${count !== 1 && 's'}`,
    served: `Served an ad to ${count} hashed ad_id${count !== 1 && 's'}`,
    deleted: "Subject's data has been removed from the system",
  };
  return mapping[value];
};

export enum MATCH_RATE_STATUS {
  Failed = 'failed',
  Pending = 'pending',
  Succeeded = 'succeeded',
}
export enum QUERY_STATUS {
  Queued = 'queued',
  Running = 'running',
  Streaming = 'streaming',
  Failed = 'failed',
  Succeeded = 'succeeded',
}

export enum VAULT_IDS {
  fimp_pqs_1 = 'fimp_pqs_1',
}

// Divide by 60 to get hours ahead of UTC. (e.g. SG, GMT+8 : 8*60=480)
export const TIMEZONE_MAPPING = {
  330: 'IST',
  480: 'SGT',
  540: 'KST',
};


export const DEFAULT_COLOR_CODE = {
  PRIMARY_COLOR_CODE : '#e4554b',
  SECONDARY_COLOR_CODE : '#CCCCCC',
  BUTTON_TEXT_COLOR : '#FFFFFF'
};


export const CONSTANTS = {
  BACK_BUTTON : 'Back',
  NEWQUERY_BUTTON : 'New Query',
  SEARCH_BUTTON : 'Search',
  RELOAD : 'RELOAD'
};

export const MENU_ICON_SHAPE = {
  DIAMOND : 'diamond',
  SQUARE : 'square',
  CIRCLE : 'circle'
};






